export const RecommendationsRoutes = [
  {
    path: 'recommendations',
    alias: 'recommendations',
    query: ['channel'],
    lazy: () => import('./recommendations.page'),
  },
] as const
